module.exports = __webpack_public_path__ + "img/1.a96f9cfd.png";